export default __webpack_public_path__ + "static/Group 61-d91f06cc28543fdaa26e7ba6a4f38648.png";